export const getUrl = (url, theme = 'light', params) => {
    const { origin } = window.location;
    const queryParams = new URLSearchParams(params);
    if (theme === 'dark') {
        queryParams.set('theme', 'dark');
    }
    return `${origin}/${url}?${queryParams.toString()}`;
};
